// URLs de Cloudinary — pegar la URL de cada imagen después de subirla
// Formato: https://res.cloudinary.com/thq31ls4/image/upload/v.../nombre.ext

// --- Carga en cada visita ---
export const COFFEE_BG = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1920/v1784627611/coffee-bg.webp";
export const FOOTER_BG = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1920/v1784627612/footer-bg.png";
export const FOTO_STICKER = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_800/v1784627613/foto-sticker.webp";

// --- Locations ---
export const BELGRANO = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1000/v1784627614/belgrano.png";
export const PALERMO = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1000/v1784627615/palermo.jpg";
export const RECOLETA = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1000/v1784627616/recoleta.webp";
export const VALENCIA = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1000/v1784627617/valencia.png";

// --- Galería principal (6 imágenes en orden de aparición) ---
export const GALLERY_1 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627618/gallery-1.png";
export const GALLERY_2 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627619/gallery-2.png";
export const GALLERY_3 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627620/gallery-3.jpg";  // era Image-2.jpg, solo desktop
export const GALLERY_4 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627621/gallery-4.jpg";
export const GALLERY_5 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627622/gallery-5.png";
export const GALLERY_6 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_1200/v1784627623/gallery-6.png";

// --- Instagram ---
export const INSTA_1 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_600/v1784627624/insta-1.png";
export const INSTA_2 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_600/v1784627625/insta-2.png";
export const INSTA_3 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_600/v1784627625/insta-3.png";
export const INSTA_4 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_600/v1784627627/insta-4.png";
export const INSTA_5 = "https://res.cloudinary.com/thq31ls4/image/upload/f_auto,q_auto,c_limit,w_600/v1784627627/insta-5.png";

// --- Prensa ---
export const PRENSA_0 = "";         // Prensa-M-0.png (192KB)
export const PRENSA_1 = "";         // Prensa-M-1.png (304KB)
export const PRENSA_2 = "";         // Prensa-M-2.png (336KB)
export const PRENSA_3 = "";         // Prensa-M-3.png (220KB)
export const PRENSA_4 = "";         // Prensa-M-4.png (312KB)
export const PRENSA_5 = "";         // Prensa-M-5.png (256KB)
export const PRENSA_6 = "";         // Prensa-M-6.png (280KB)
export const PRENSA_7 = "";         // Prensa-M-7.png (140KB)
export const PRENSA_8 = "";         // Prensa-M-8.png (204KB)
export const PRENSA_9 = "";         // Prensa-M-9.png (284KB)
export const PRENSA_10 = "";        // Prensa-M-10.png (148KB)

// --- Menú: Almuerzo ---
export const ALMUERZO_1 = "";       // Almuerzo1.webp
export const ALMUERZO_3 = "";       // Almuerzo3.webp
export const ALMUERZO_4 = "";       // Almuerzo4.webp
export const ALMUERZO_5 = "";       // Almuerzo5.webp
export const ALMUERZO_NEW_2 = "";   // Almuerzo-New-2.webp
export const ALMUERZO_NEW_3 = "";   // Almuerzo-New-3.webp
export const ALMUERZO_NEW_4 = "";   // Almuerzo-New-4.webp
export const ALMUERZO_NEW_5 = "";   // Almuerzo-New-5.webp
export const ALMUERZO_NEW_6 = "";   // Almuerzo-New-6.webp
export const ALMUERZO_NEW_7 = "";   // Almuerzo-New-7.webp
export const ALMUERZO_NEW_8 = "";   // Almuerzo-New-8.webp
export const ALMUERZO_NEW_9 = "";   // Almuerzo-New-9.webp

// --- Menú: Bebidas ---
export const BEBIDAS_1 = "";        // Bebidas1.webp
export const BEBIDAS_2 = "";        // Bebidas2.webp
export const BEBIDAS_3 = "";        // Bebidas3.webp
export const BEBIDAS_NEW_1 = "";    // Bebidas-New-1.webp
export const BEBIDAS_NEW_2 = "";    // Bebidas-New-2.webp
export const BEBIDAS_NEW_3 = "";    // Bebidas-New-3.webp
export const BEBIDAS_NEW_4 = "";    // Bebidas-New-4.webp
export const BEBIDAS_NEW_5 = "";    // Bebidas-New-5.webp
export const BEBIDAS_NEW_6 = "";    // Bebidas-New-6.webp
export const BEBIDAS_NEW_7 = "";    // Bebidas-New-7.webp
export const BEBIDAS_NEW_8 = "";    // Bebidas-New-8.webp
export const BEBIDAS_NEW_9 = "";    // Bebidas-New-9.webp
export const BEBIDAS_NEW_10 = "";   // Bebidas-New-10.webp
export const BEBIDAS_NEW_11 = "";   // Bebidas-New-11.webp

// --- Menú: Pastelería ---
export const PASTELERIA_1 = "";     // Pasteleria1.webp
export const PASTELERIA_3 = "";     // Pasteleria3.webp
export const PASTELERIA_4 = "";     // Pasteleria4.webp
export const PASTELERIA_5 = "";     // Pasteleria5.webp
export const PASTELERIA_6 = "";     // Pasteleria6.webp
export const PASTELERIA_7 = "";     // Pasteleria7.webp
export const PASTELERIA_8 = "";     // Pasteleria8.webp
export const PASTELERIA_9 = "";     // Pasteleria9-9.webp
export const PASTELERIA_10 = "";    // Pasteleria10.webp
